export const campaign = (state) => {
  return state.campaign
}

export const campaigns = (state) => {
  return state.campaigns
}

export const targets = (state) => {
  return state.targets
}

export const targetDetail = (state) => {
  return state.targetDetail
}

export const ruleChains = (state) => {
  return state.ruleChains
}
